import { createFileRoute } from "@tanstack/react-router";
import { SubPage } from "@/components/sub-page";
import umayor from "@/assets/partners/umayor.webp.asset.json";
import sence from "@/assets/partners/sence.png.asset.json";
import hk from "@/assets/partners/hk.svg.asset.json";
import corfo from "@/assets/partners/corfo.png.asset.json";
import auscham from "@/assets/partners/auscham.png.asset.json";
import compromisoMinero from "@/assets/partners/compromiso-minero.svg.asset.json";
import minnovex from "@/assets/partners/minnovex.png.asset.json";
import andesmets from "@/assets/partners/andesmets-real.png.asset.json";
import holoniq from "@/assets/partners/holoniq.png.asset.json";
import lsqa from "@/assets/partners/lsqa.png.asset.json";
import aia from "@/assets/partners/aia.svg.asset.json";

export const Route = createFileRoute("/quienes-somos/alianzas")({
  head: () => ({
    meta: [
      { title: "Alianzas y Certificaciones | Mine Class" },
      { name: "description", content: "Alianzas estratégicas, socios y certificaciones de Mine Class." },
      { property: "og:title", content: "Alianzas y Certificaciones | Mine Class" },
      { property: "og:description", content: "Conoce las alianzas estratégicas, socios académicos y certificaciones que respaldan a Mine Class." },
      { property: "og:url", content: "https://mine-class.com/quienes-somos/alianzas" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mine-class.com/quienes-somos/alianzas" }],
  }),
  component: Page,
});

type LogoItem = { name: string; src?: string };

const ALIANZAS: LogoItem[] = [
  { name: "Universidad Mayor", src: umayor.url },
  { name: "SENCE", src: sence.url },
  { name: "Fundación HK", src: hk.url },
];

const SOCIOS: LogoItem[] = [
  { name: "ANDESMETS", src: andesmets.url },
  { name: "Compromiso Minero", src: compromisoMinero.url },
  { name: "Minnovex", src: minnovex.url },
  { name: "Auscham", src: auscham.url },
  { name: "CORFO", src: corfo.url },
  { name: "AIA", src: aia.url },
];

const CERTIFICACIONES: LogoItem[] = [
  { name: "LSQA · NCh 2728", src: lsqa.url },
  { name: "HolonIQ LATAM EdTech 100", src: holoniq.url },
];

function LogoRow({ title, items }: { title: string; items: LogoItem[] }) {
  return (
    <section className="border border-[var(--color-outline-variant)] rounded-2xl bg-white p-6 md:p-8">
      <h3 className="text-headline-md text-[var(--color-brand-purple)] mb-6 uppercase tracking-wide">
        {title}
      </h3>
      <div className="flex flex-wrap items-center gap-x-8 gap-y-6">
        {items.map((it) =>
          it.src ? (
            <div
              key={it.name}
              className="flex items-center justify-center h-20 w-40 shrink-0"
            >
              <img
                src={it.src}
                alt={it.name}
                title={it.name}
                loading="lazy"
                className="max-h-full max-w-full object-contain transition-all duration-300"
                style={{ filter: "grayscale(1)", opacity: 0.75 }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.filter = "grayscale(0)";
                  e.currentTarget.style.opacity = "1";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.filter = "grayscale(1)";
                  e.currentTarget.style.opacity = "0.75";
                }}
              />
            </div>
          ) : (
            <div
              key={it.name}
              title={it.name}
              className="flex items-center justify-center h-20 w-40 shrink-0 font-bold text-2xl tracking-wide text-[var(--color-on-surface-variant)] hover:text-[var(--color-brand-coral)] transition-colors duration-300"
            >
              {it.name}
            </div>
          ),
        )}
      </div>
    </section>
  );
}

function Page() {
  return (
    <SubPage
      section="quienes-somos"
      eyebrow="Quiénes Somos"
      title="Alianzas y Certificaciones"
      intro="Trabajamos con las instituciones y organizaciones más relevantes de la industria."
    >
      <div className="flex flex-col gap-6 not-prose">
        <LogoRow title="Alianzas" items={ALIANZAS} />
        <LogoRow title="Socios" items={SOCIOS} />
        <LogoRow title="Certificaciones" items={CERTIFICACIONES} />
      </div>
    </SubPage>
  );
}
